// @flow

import { combineReducers } from 'redux';
import {
  ADD_IMPRESSION_POSITION,
} from './constants';
import type { ImpressionPositions } from './types';

const initialPosition = {};

const impressionPositions = (
  state: ImpressionPositions = initialPosition,
  action,
): ImpressionPositions => {
  switch (action.type) {
    case ADD_IMPRESSION_POSITION: {
      const data = state[action.pathName] || [];
      return {
        ...state,
        [action.pathName]: data.concat([action.id]),
      };
    }
    default:
      return state;
  }
};

export default combineReducers<Object, Object>({
  impressionPositions,
});
